<template>
  <div class="p">
    <!-- 学习成果 -->
    <studyAchievement v-bind="$attrs" />
    <!-- 课程人数分布 -->
    <div class="overview-head">
      <div class="overview-head__num">02</div>
      <div class="overview-head__title">班级近况</div>
    </div>
    <CourseEcharts v-bind="$attrs" v-on="$listeners" @getTableList='getTableList'
    @getSubjectList='getSubjectList'/>
    <!-- <div class="overview-head">
      <div class="overview-head__num">04</div>
      <div class="overview-head__title">需要关注的学生</div>
    </div>
    <div class="overview-stu">
      <ul class="overview-stu__habit">
        <li  v-for="item in habitList"
          :key="item.id"
          :class="{'isactive': item.id===activeId}"
          @click="habitChange(item.id)">{{item.name}}</li>
           <el-popover
              placement="top"
              title="说明"
              width="200"
              trigger="hover"
              content="为方便查看，不规范行为按周为单位统计，不满一周则自动补充为一周"
              >
              <img slot="reference"
              src="../../images/why-icon.png" class="overview-stu__tooltip" alt="">
            </el-popover>
      </ul>
      <div  @click="updateVisible">
        <check-detail title="查看全部">
      </check-detail>
      </div>
    </div> -->
  <!-- <60%就是红底红字否则蓝底蓝字 -->
     <!-- <div class="overview-time" :style="{'background':
     classRightRate<60&&classRightRate>0?'#FEE9E9':'#DDEEFE'}">
        {{start}}~{{end}}期间，<span>{{subjectName}}</span>科目中，班级
        <p v-if="activeId===0">
          平均正答率
        <span :style="{'color':
        classRightRate<60&&classRightRate>0?'#F56C6C':'#1989FA'
        }">{{classRightRate===-100?'—-':classRightRate}}</span>
          %
         <p v-if="activeId===1">
         平均不规范行为<span>{{warnAverage}}</span>次
        </p>
    </div> -->
    <!-- <div v-show="activeId===0">
      <el-table
      :data="rightLowList"
      style="width: 100%"

      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="300"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        width="300"
        align="center"
       >
      </el-table-column>
      <el-table-column
        prop="question_num"
        label="总答题数"
        align="center"
        sortable
        >
        <template slot-scope="scope">
            {{scope.row.question_num ===  -1 ? '--':scope.row.question_num}}
        </template>
      </el-table-column>
      <el-table-column
        prop="right_rate"
        label="客观题正答率"
        align="center"
        sortable
        >
        <template slot-scope="scope">
            {{scope.row.right_rate ===  -1 ? '--':scope.row.right_rate}}%
        </template>
      </el-table-column>
    </el-table>
    </div> -->
    <!-- <div v-show="activeId===1">
      <el-table
      :data="habitImproveList"
      style="width: 100%"

      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="300"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        width="200"
        align="center"
       >
      </el-table-column>
      <el-table-column
        prop="warn_cnt"
        label="课堂不规范行为总次数"
        align="center"
        sortable
        >
         <template slot-scope="scope">
            {{scope.row.warn_cnt}}次
        </template>
      </el-table-column>
      <el-table-column
        prop="warn_cnt_detail.warn_wrong_answer_cnt"
        label="连续答错次数"
        align="center"
        sortable
        >
        <template slot-scope="scope">
            {{scope.row.warn_cnt_detail.warn_wrong_answer_cnt}}次
        </template>
      </el-table-column>
       <el-table-column
        prop="warn_cnt_detail.warn_video_cnt"
        label="视频不认真看次数"
        align="center"
        sortable
        >
        <template slot-scope="scope">
            {{scope.row.warn_cnt_detail.warn_video_cnt}}次
        </template>
      </el-table-column>
       <el-table-column
        prop="warn_cnt_detail.warn_no_action_cnt"
        label="长时间发呆次数"
        align="center"
        sortable
        >
          <template slot-scope="scope">
            {{scope.row.warn_cnt_detail.warn_no_action_cnt}}次
        </template>
      </el-table-column>
    </el-table>
    </div> -->
    <DialogContent
      :dialogVisible.sync="dialogVisible"
      :title="title"
      :type="type"
      :subjectList="subjectList"
      :studyResults="studyResults"
      ref="dialogContent"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import studyAchievement from './study-achievement.vue';
import CourseEcharts from './course-echarts.vue';
// import EmptyContent from '@/views/pt/components/empty.vue';
// import CheckDetail from './check-detail.vue';
import DialogContent from './dialog-content.vue';
import { subjectIdToSubjectName } from '@/utils/index';

export default {
  name: 'ClassProfile',
  components: {
    studyAchievement,
    CourseEcharts,
    // EmptyContent,
    // CheckDetail,
    DialogContent,
  },
  data() {
    return {
      habitList: [{
        name: '正答率较低的学生',
        id: 0,
      }, {
        name: '课堂不规范行为的学生',
        id: 1,
      }],
      title: '', // 弹窗标题
      type: '1', // 弹窗类型
      studyResults: {},
      habitImproveList: [],
      rightLowList: [],
      studyList: [],
      subjectId: 0,
      subjectName: '',
      subjectList: [],
      activeId: 0,
      start: '',
      end: '',
      dialogVisible: false,
      classRightRate: '', // 班级平均正答率
      warnAverage: '', // 班级平均不规范行为
      week_num: '', // 周
    };
  },
  created() {
    this.bus.$on('send', (start, end) => {
      this.start = start;
      this.end = end;
    });
  },
  watch: {
    // subjectId() {
    //   this.habitList[0].active = true;
    //   this.habitList[1].active = false;
    // },
  },
  methods: {
    habitChange(id) {
      this.activeId = id;
      this.title = this.habitList[id].name;
      if (id === 0) {
        this.type = '1';
      } else {
        this.type = '2';
      }
    },
    getTableList(value, subjectId) {
      this.studyResults = value;
      this.habitImproveList = value.habit_improve_list;
      this.classRightRate = value.class_right_rate;
      this.warnAverage = value.warn_average;
      this.week_num = value.week_num;
      this.rightLowList = value.right_low_list || [];
      this.studyList = this.habitImproveList;
      this.subjectId = subjectId;
      this.subjectName = subjectIdToSubjectName(subjectId);
      if (this.subjectId === 3) {
        this.habitList = [{
          name: '课堂不规范行为的学生',
          id: 1,
        }];
        this.activeId = 1;
        this.type = '2';
        this.title = this.habitList[0].name;
      } else {
        this.habitList = [{
          name: '正答率较低的学生',
          id: 0,
        }, {
          name: '课堂不规范行为的学生',
          id: 1,
        }];
        this.activeId = 0;
        this.type = '1';
        this.title = this.habitList[0].name;
      }
    },
    getSubjectList(value) {
      this.subjectList = value;
    },
    updateVisible() {
      this.dialogVisible = true;
      this.$refs.dialogContent.pickChange();
    },

  },
};
</script>

<style lang="scss" scoped>
.p{
  padding-bottom:40px ;
  .overview-head{
    display: flex;
    padding:45px 0 0 19px;
    align-items: center;
    margin-bottom: 32px;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background: url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }

}
  .overview-stu{
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  &__habit{
    display: flex;
    font-size: 14px;
    // width: 376px;
    height: 40px;
    background: #F0F2F5;
    border-radius: 4px;
    padding: 2px;
    line-height: 40px;
    box-sizing: border-box;
    position: relative;
    color: #303133;

    li {
      width: 186px;
      text-align: center;
      font-weight: 500;
      cursor: pointer;
    }
  }
  &__tooltip {
     position: absolute;
      width: 16px;
      height: 16px;
      text-align: center;
      vertical-align:text-bottom;
      right: 8px;
      top: 13px;
    }
  }
  .overview-time{
    height: 52px;
    background: #FEE9E9;
    border-radius: 4px;
    line-height: 52px;
    padding-left:30px ;
    margin-bottom: 18px;
    font-size: 17px;
    font-weight: 500;
    p{
      color: #343639;
      display: inline;
    }
     span{
      color: #1989FA;
      }
  }
}
.isactive {
  color: #1989FA;
  background: #FFFFFF;
  border-radius: 2px;
}
::v-deep {
  .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
}
</style>
